var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}function ownKeys(e, r) {var t = Object.keys(e);if (Object.getOwnPropertySymbols) {var o = Object.getOwnPropertySymbols(e);r && (o = o.filter(function (r) {return Object.getOwnPropertyDescriptor(e, r).enumerable;})), t.push.apply(t, o);}return t;}function _objectSpread(e) {for (var r = 1; r < arguments.length; r++) {var t = null != arguments[r] ? arguments[r] : {};r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {_defineProperty(e, r, t[r]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));});}return e;}function _defineProperty(e, r, t) {return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e;}function _toPropertyKey(t) {var i = _toPrimitive(t, "string");return "symbol" == typeof i ? i : i + "";}function _toPrimitive(t, r) {if ("object" != typeof t || !t) return t;var e = t[Symbol.toPrimitive];if (void 0 !== e) {var i = e.call(t, r || "default");if ("object" != typeof i) return i;throw new TypeError("@@toPrimitive must return a primitive value.");}return ("string" === r ? String : Number)(t);}import React from 'react';
import { connect } from 'react-redux';
import { actions as formActions } from 'react-redux-form';
import { withContext, withRouter } from "../componentWrappers";
import RouteHandler from "../App/RouteHandler";
import { actions } from "../BasicReducer";
import { Loader } from "../components/Elements/Loader";
import * as uiActions from "../Entities/actions/uiActions";

import { store } from "../store";
import { setDocuments, unsetDocuments } from "../Library/actions/libraryActions";
import { processQuery } from "../Library/helpers/requestState";
import { wrapDispatch } from "../Multireducer";
import * as relationships from "../Relationships/utils/routeUtils";
import relationTypesAPI from "../RelationTypes/RelationTypesAPI";
import * as reviewActions from "./actions/actions";
import { OneUpEntityViewer } from "./components/OneUpEntityViewer";
import api from "../Search/SearchAPI";
import TemplatesAPI from "../Templates/TemplatesAPI";
import ThesauriAPI from "../Thesauri/ThesauriAPI";

import { setReferences } from "../Viewer/actions/referencesActions";
import { propertyTypes } from "../../shared/propertyTypes";












function buildInitialOneUpState(
documentsRequest,
numDocuments,
thesauri,
templates)
{var _documentsRequest$dat, _documentsRequest$dat2;
  const thesaurusValues = [];
  const thesauriKeys = Object.keys((_documentsRequest$dat = (_documentsRequest$dat2 = documentsRequest.data) === null || _documentsRequest$dat2 === void 0 ? void 0 : _documentsRequest$dat2.filters) !== null && _documentsRequest$dat !== void 0 ? _documentsRequest$dat : {}).reduce((res, k) => {
    const propName = k.startsWith('__') ? k.substring(2) : k;
    if (k.startsWith('__')) {
      thesaurusValues.push(
        ...documentsRequest.data.filters[k].values.filter(
          (v) => v && !['any', 'missing'].includes(v)
        )
      );
    }
    return _objectSpread(_objectSpread({},
    res),
    templates.reduce((res2, tmpl) => {
      const prop = (tmpl.properties || []).find((p) => p.name === propName);
      if (
      !prop ||
      !prop.content ||
      prop.type !== propertyTypes.select && prop.type !== propertyTypes.multiselect)
      {
        return res2;
      }
      return _objectSpread(_objectSpread({}, res2), {}, { [prop.content]: true });
    }, {}));

  }, {});
  const thesaurus =
  Object.keys(thesauriKeys).length === 1 ?
  thesauri.find((t) => t._id.toString() === Object.keys(thesauriKeys)[0]) :
  null;
  thesauri.forEach((t) => {
    (t.values || []).forEach((tv) => {
      const i = thesaurusValues.findIndex((v) => v === tv.id);
      if (i >= 0) {
        thesaurusValues[i] = tv.label;
      }
    });
  });
  return {
    loaded: true,
    fullEdit: false,
    loadConnections: false,
    indexInDocs: 0,
    totalDocs: numDocuments,
    maxTotalDocs: 5001,
    requestHeaders: documentsRequest.headers,
    reviewThesaurusName: thesaurus ? thesaurus.name : '',
    reviewThesaurusId: thesaurus ? thesaurus._id.toString() : '',
    reviewThesaurusValues: thesaurusValues
  };
}

class OneUpReviewBase extends RouteHandler {
  static async requestState(requestParams, state) {
    const documentsRequest = requestParams.set(_objectSpread(_objectSpread({},
    processQuery(requestParams.data, state)), {}, {
      limit: 5001,
      select: ['sharedId'],
      unpublished: !!requestParams.data.unpublished,
      includeUnpublished: !!requestParams.data.includeUnpublished })
    );

    const [templates, thesauri, relationTypes, documents] = await Promise.all([
    TemplatesAPI.get(requestParams.onlyHeaders()),
    ThesauriAPI.getThesauri(requestParams.onlyHeaders()),
    relationTypesAPI.get(requestParams.onlyHeaders()),
    api.search(documentsRequest)]
    );

    const firstSharedId = documents.rows.length ? documents.rows[0].sharedId : '';

    return [
    actions.set('relationTypes', relationTypes),
    (dispatch) => wrapDispatch(dispatch, 'library')(unsetDocuments()),
    (dispatch) => wrapDispatch(dispatch, 'library')(setDocuments(documents)),
    actions.set(
      'oneUpReview.state',
      buildInitialOneUpState(documentsRequest, documents.rows.length, thesauri, templates)
    ),
    ...(firstSharedId ?
    await reviewActions.getAndLoadEntity(
      requestParams.set({ sharedId: firstSharedId }),
      templates,
      state,
      false
    ) :
    [])];

  }

  urlHasChanged(nextProps) {
    const nextSearchParams = new URLSearchParams(nextProps.location.search);
    const currentSearchParams = new URLSearchParams(this.props.location.search);
    return nextSearchParams.get('q') !== currentSearchParams.get('q');
  }

  componentWillUnmount() {
    this.emptyState();
  }

  componentDidMount() {
    store === null || store === void 0 ? void 0 : store.dispatch(uiActions.showTab('info'));
  }

  emptyState() {
    wrapDispatch(store === null || store === void 0 ? void 0 : store.dispatch, 'library')(unsetDocuments());
    store === null || store === void 0 ? void 0 : store.dispatch(setReferences([]));
    store === null || store === void 0 ? void 0 : store.dispatch(actions.unset('entityView/entity'));
    store === null || store === void 0 ? void 0 : store.dispatch(formActions.reset('entityView.entityForm'));
    store === null || store === void 0 ? void 0 : store.dispatch(relationships.emptyState());
    actions.set('oneUpReview.state', {});
  }

  render() {
    const { entity, oneUpState } = this.props;
    if (
    !oneUpState ||
    !oneUpState.get('loaded') ||
    oneUpState.get('totalDocs') && (!entity || !entity.get('_id')))
    {
      return /*#__PURE__*/_jsx(Loader, {});
    }
    return /*#__PURE__*/_jsx(OneUpEntityViewer, { mainContext: this.props.mainContext });
  }
}










const mapStateToProps = (state) => (
{
  entity: state.entityView.entity,
  oneUpState: state.oneUpReview.state
});


export { OneUpReviewBase };
//@ts-ignore
export default connect(mapStateToProps)(withRouter(withContext(OneUpReviewBase)));